export default __webpack_public_path__ + "static/media/icon_alert-outlined.b42ca814.svg";